import React from 'react'
import TrackVisibility from 'react-on-screen'

// Components import
import SEO from '../components/seo'
import Header from '../components/main/Header'
import Banner from '../components/main/Banner'
import Navbar from '../components/main/Navbar'
import Body from '../components/main/Body'
import Footer from '../components/main/Footer'

// THE PORTFOLIO PAGE
const Home = () => {
  return (
    <>
      <SEO
        title="Pragun Saini | Portfolio"
        description="My personal portfolio site, created by myself, Pragun Saini"
      />
      <div className="main">
        <Banner />
        <Header />
        <Navbar />
        <Body />
        <TrackVisibility className="footer-cover" once partialVisibility>
          <Footer />
        </TrackVisibility>
      </div>
    </>
  )
}

export default Home
